import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

import AuthLayout from "../layouts/AuthLayout.vue";
import AppLayout from "../layouts/AppLayout.vue";

import RouteViewComponent from "../layouts/RouterBypass.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "404" },
  },
  {
    name: "admin",
    path: "/",
    component: AppLayout,
    redirect: { name: "profile" },
    children: [
      {
        name: "dashboard",
        path: "dashboard",
        component: () => import("../pages/workdesk/admin/dashboard/Dashboard.vue"),
        meta: { roles: ["CEO", "CTO", "CGO", "CFO", "COO"] },
      },
      {
        name: "preferences",
        path: "preferences",
        component: () => import("../pages/user-settings/preferences/Preferences.vue"),
      },
      {
        name: "profile",
        path: "profile",
        component: () => import("../pages/user-settings/profile/Profile.vue"),
      },
      {
        name: "employees",
        path: "employees",
        component: () => import("../pages/workdesk/employee/EmployeesPage.vue"),
        meta: { roles: ["Manager HR", "CHRO", "CEO"] },
      },
      {
        name: "customers",
        path: "customers",
        component: () => import("../pages/user-settings/customer/CustomersPage.vue"),
        meta: { roles: ["CTO", "CEO"] },
      },
      {
        name: "lender-partner",
        path: "lender-partner",
        component: () =>
          import("../pages/partner/lender-partner/LenderPartnerPage.vue"),
        meta: { roles: ["CGO", "PM Sales", "CEO"] },
      },
      {
        name: "channel-partner",
        path: "channel-partner",
        component: () =>
          import("../pages/partner/channel-partner/ChannelPartnerPage.vue"),
        meta: { roles: ["CGO", "PM Sales", "CEO"] },
      },
      {
        name: "loan-request",
        path: "loan-request",
        component: () => import("../pages/loans/loan-request/LoanRequestsPage.vue"),
        meta: { roles: ["CTO", "CGO", "CEO"] },
      },
      {
        name: "loan-enquiry",
        path: "loan-enquiry",
        component: () => import("../pages/loans/loan-enquiry/LoanEnquiryPage.vue"),
        meta: { roles: ["CTO", "CGO", "CEO"] },
      },
      {
        name: "lms",
        path: "lms",
        component: () => import("../pages/loans/lms/LMSPage.vue"),
        meta: { roles: ["CTO", "CFO", "CEO"] },
      },
      {
        name: "all-tickets",
        path: "all-tickets",
        component: () => import("../pages/tickets-issue/all-tickets/AllTicketsPage.vue"),
        meta: { roles: ["COO", "Manger Operations", "CEO"] },
      },
      {
        name: "issue",
        path: "issue",
        component: () => import("../pages/tickets-issue/issue/IssuePage.vue"),
        meta: {
          roles: ["COO", "Manger Operations", "Executive", "GRO", "CEO"],
        },
      },
      {
        name: "offer",
        path: "offer",
        component: () => import("../pages/updates/offer/OfferPage.vue"),
        meta: { roles: ["PM Marketing", "CGO", "CEO"] },
      },
      {
        name: "blogs",
        path: "blogs",
        component: () => import("../pages/updates/blog/BlogPage.vue"),
        meta: { roles: ["PM Marketing", "CGO", "CEO"] },
      },
      {
        name: "messages",
        path: "messages",
        component: () => import("../pages/updates/message/MessagePage.vue"),
        meta: { roles: ["COO", "Manger Operations", "CEO"] },
      },
      {
        name: "notification",
        path: "notification",
        component: () => import("../pages/updates/notification/NotificationPage.vue"),
        meta: { roles: ["PM Marketing", "CGO", "CEO"] },
      },
      {
        name: "employee-attendance",
        path: "employee-attendance",
        component: () => import("../pages/workdesk/attendance/Attendance.vue"),
        meta: { roles: ["CEO", "CTO", "CGO", "CFO", "COO", "Manager HR", "CHRO", "PM Sales", "Manger Operations", "Executive", "GRO", "PM Marketing", "Field Sales Executive", "Intern"] },
      },
      {
        name: "staff-attendance",
        path: "staff-attendance",
        component: () => import("../pages/workdesk/staff-attendance/StaffAttendance.vue"),
        meta: { roles: ["CEO", "CTO", "Manager HR"] },
      },
      {
        name: "leave-hub",
        path: "leave-hub",
        component: () => import("../pages/workdesk/leave-hub/LeaveHub.vue"),
        meta: { roles: ["CEO", "CTO", "CGO", "CFO", "COO", "Manager HR", "CHRO", "PM Sales", "Manger Operations", "Executive", "GRO", "PM Marketing", "Field Sales Executive", "Intern"] },
      },
      {
        name: "leave-management",
        path: "leave-management",
        component: () => import("../pages/workdesk/leave-management/LeaveManagement.vue"),
        meta: { roles: ["CEO", "CTO", "Manager HR"] },
      },
      {
        name: "payroll",
        path: "payroll",
        component: () => import("../pages/workdesk/payroll/Payroll.vue"),
        meta: { roles: ["CEO", "CTO", "Manager HR"] },
      },
      {
        name: "documents",
        path: "documents",
        component: () => import("../pages/workdesk/documents/Documents.vue"),
        meta: { roles: ["CEO", "CTO", "CGO", "CFO", "COO", "Manager HR", "CHRO", "PM Sales", "Manger Operations", "Executive", "GRO", "PM Marketing", "Field Sales Executive", "Intern"] },

      },
    ],
  },
  {
    path: "/auth",
    component: AuthLayout,
    children: [
      {
        name: "login",
        path: "login",
        component: () => import("../pages/user-settings/auth/Login.vue"),
      },
      {
        name: "signup",
        path: "signup",
        component: () => import("../pages/user-settings/auth/Signup.vue"),
      },
      {
        name: "recover-password",
        path: "recover-password",
        component: () => import("../pages/user-settings/auth/RecoverPassword.vue"),
      },
      {
        name: "recover-password-email",
        path: "recover-password-email",
        component: () => import("../pages/user-settings/auth/CheckTheEmail.vue"),
      },
      {
        path: "",
        redirect: { name: "login" },
      },
    ],
  },
  {
    name: "404",
    path: "/404",
    component: () => import("../pages/404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: "smooth" };
    } else {
      window.scrollTo(0, 0);
    }
  },
  routes,
});

// Mock role source (replace this with your actual auth store or composable)
function getUserRole() {
  return localStorage.getItem("role"); // e.g., "admin", "user", etc.
}

router.beforeEach((to, from, next) => {
  const requiredRoles = to.meta?.roles;

  // No role restriction: allow access
  if (!requiredRoles) return next();

  const userRole = getUserRole();

  // If user role is allowed → proceed
  if (requiredRoles.includes(userRole)) return next();

  // User not authorized → redirect
  return next({ name: "404" }); // or redirect to a "forbidden" page
});

export default router;
